import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Shield } from 'lucide-react'
import { auth } from '../lib/supabase'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)

    const { error: resetError } = await auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    })

    if (resetError) {
      setError(resetError.message)
      setIsLoading(false)
      return
    }

    setSent(true)
    setIsLoading(false)
  }

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_#f6fbff,_#e9eff6_52%,_#e3ebf3)] px-4 py-8">
      <div className="mx-auto max-w-md">
        <div className="app-surface overflow-hidden">
          <div className="border-b border-slate-200 bg-white px-6 py-4">
            <div className="flex items-center gap-2">
              <div className="rounded-lg bg-[var(--brand-primary)] p-1.5 text-white">
                <Shield size={16} />
              </div>
              <span className="font-brand text-xl font-bold text-[var(--brand-deep)]">ASC Survey</span>
            </div>
            <p className="mt-2 text-sm font-semibold text-slate-600">Reset Your Password</p>
          </div>

          {sent ? (
            <div className="px-6 py-8 text-center space-y-3">
              <p className="text-sm font-semibold text-emerald-700">Password reset link sent to {email}</p>
              <p className="text-xs text-slate-500">Check your email and follow the link to set a new password.</p>
              <Link to="/login" className="inline-block text-sm font-semibold text-[var(--brand-primary)] hover:underline">
                Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4 px-6 py-5">
              <div>
                <label htmlFor="reset-email" className="block text-xs font-bold uppercase tracking-wider text-slate-500">
                  Email
                </label>
                <input
                  id="reset-email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm focus:border-[var(--brand-primary)] focus:outline-none focus:ring-2 focus:ring-blue-100"
                />
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <button type="submit" disabled={isLoading} className="btn-primary w-full py-2.5 text-sm disabled:opacity-60">
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <Link to="/login" className="block w-full text-center text-sm font-semibold text-[var(--brand-primary)] hover:underline">
                Back to login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
